import { render, staticRenderFns } from "./promotion-resources-form-wrapper.vue?vue&type=template&id=3a7b7d5a"
import script from "./promotion-resources-form-wrapper.vue?vue&type=script&lang=js"
export * from "./promotion-resources-form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports